import {DataTransferObjectValidation} from "../../../type/Types";
import {CampaignPolicyValueObject} from "../../vo/campaign/CampaignPolicyValueObject";

export namespace CampaignPolicyDataTransferObject {
    export type Post = {
        enableMinute: number | null,
        disableMinute: number | null,
        enableFixedAmount: number | null,
        disableFixedAmount: number | null,
        currentAmount: number | null,
        thresholdValue: number | null,
        isAboveThreshold: boolean,
    }

    export namespace Post {
        export const description: Record<keyof Post, string> = CampaignPolicyValueObject.description

        export const validation: DataTransferObjectValidation<Post> = {
            enableMinute(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('enableMinute', { cause: e })
                }
            },
            disableMinute(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('disableMinute', { cause: e })
                }
            },
            enableFixedAmount(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('enableFixedAmount', { cause: e })
                }
            },
            disableFixedAmount(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('disableFixedAmount', { cause: e })
                }
            },
            currentAmount(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('currentAmount', { cause: e })
                }
            },
            thresholdValue(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('thresholdValue', { cause: e })
                }
            },
            isAboveThreshold(o: string): boolean {
                return o === 'true'
            },

        }
    }

    export type Put = {
        enableMinute: number | null,
        disableMinute: number | null,
        enableFixedAmount: number | null,
        disableFixedAmount: number | null,
        currentAmount: number | null,
        thresholdValue: number | null,
        isAboveThreshold: boolean,
    }

    export namespace Put {
        export const description: Record<keyof Put, string> = CampaignPolicyValueObject.description

        export const validation: DataTransferObjectValidation<Put> = {
            enableMinute(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('enableMinute', { cause: e })
                }
            },
            disableMinute(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('disableMinute', { cause: e })
                }
            },
            enableFixedAmount(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('enableFixedAmount', { cause: e })
                }
            },
            disableFixedAmount(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('disableFixedAmount', { cause: e })
                }
            },
            currentAmount(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('currentAmount', { cause: e })
                }
            },
            thresholdValue(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('thresholdValue', { cause: e })
                }
            },
            isAboveThreshold(o: string): boolean {
                return o === 'true'
            },

        }
    }
}

